'use client';

import { c as _c } from "react/compiler-runtime";
import { MessageBox } from '@7f-ui/components/message-box/message-box';
import type { CartCurrencyProductType } from '@feat/feat-tracking/message';
import { trackCartCurrencyMismatch } from '@feat/feat-tracking/message';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { useEffect } from 'react';
import { useCartCurrency, useIsCartCurrencyMismatch } from '../src/cart-currency-context';
const CART_CURRENCY_MISMATCH_BOX_LABELS: Record<string, string> = {
  accommodation: 'In deinem Warenkorb liegt bereits etwas in einer anderen Währung. Bitte ändere die Währung oder lösche deinen Warenkorb, um diese Unterkunft hinzufügen zu können.',
  beach_chair: 'In deinem Warenkorb liegt bereits etwas in einer anderen Währung. Bitte ändere die Währung oder lösche deinen Warenkorb, um diesen Strandkorb hinzufügen zu können.',
  experience: 'In deinem Warenkorb liegt bereits etwas in einer anderen Währung. Bitte ändere die Währung oder lösche deinen Warenkorb, um dieses Erlebnis hinzufügen zu können.',
  rentable: 'In deinem Warenkorb liegt bereits etwas in einer anderen Währung. Bitte ändere die Währung oder lösche deinen Warenkorb, um dieses Fahrrad hinzufügen zu können.',
  toCart: 'Zum Warenkorb'
};
type CartCurrencyMismatchBoxProps = {
  productCurrency: string | undefined;
  productType: CartCurrencyProductType;
  className?: string;
};
export function CartCurrencyMismatchBox(t0) {
  const $ = _c(11);
  const {
    productCurrency,
    productType,
    className
  } = t0;
  const cartCurrency = useCartCurrency();
  const isMismatch = useIsCartCurrencyMismatch(productCurrency);
  let t1;
  let t2;
  if ($[0] !== cartCurrency || $[1] !== isMismatch || $[2] !== productCurrency || $[3] !== productType) {
    t1 = () => {
      if (!isMismatch || cartCurrency === null || productCurrency === undefined) {
        return;
      }
      trackCartCurrencyMismatch({
        type: productType,
        cartCurrency,
        productCurrency
      });
    };
    t2 = [isMismatch, productType, cartCurrency, productCurrency];
    $[0] = cartCurrency;
    $[1] = isMismatch;
    $[2] = productCurrency;
    $[3] = productType;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (!isMismatch) {
    return null;
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      href: "/cart",
      label: "Zum Warenkorb"
    };
    t4 = shopTestId("CartCurrencyMismatchBox.root");
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  const t5 = CART_CURRENCY_MISMATCH_BOX_LABELS[productType] ?? productType;
  let t6;
  if ($[8] !== className || $[9] !== t5) {
    t6 = <MessageBox className={className} type="error" action={t3} testId={t4}>{t5}</MessageBox>;
    $[8] = className;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}